import {
	TASK,
	type HierarchyParent,
} from '@atlassian/jira-business-common/src/common/types/hierarchy.tsx';
import { useFilteredViewContextInput } from '@atlassian/jira-business-filters/src/controllers/default-query-input/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { useGroupBy } from '../../group-by/index.tsx';

type HierarchyConfig = {
	showFlatList: boolean;
	hierarchyParent?: HierarchyParent;
};

export const useHierarchyConfig = (): HierarchyConfig => {
	const { isFiltering } = useFilteredViewContextInput({ view: 'list' });
	const [groupByFieldId] = useGroupBy();

	const hierarchyParent = !isFiltering ? TASK : undefined;

	if (fg('flat_lists_in_groups')) {
		const showFlatList = isFiltering || groupByFieldId != null;

		return {
			showFlatList,
			hierarchyParent: showFlatList ? undefined : hierarchyParent,
		};
	}

	return {
		showFlatList: isFiltering,
		hierarchyParent,
	};
};
